import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1077c04a&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1077c04a')) {
      api.createRecord('1077c04a', component.options)
    } else {
      api.reload('1077c04a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1077c04a&", function () {
      api.rerender('1077c04a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/playground/locales/index.vue"
export default component.exports